import { render } from "./TheNav.vue?vue&type=template&id=d68c4a12"
import script from "./TheNav.vue?vue&type=script&lang=ts"
export * from "./TheNav.vue?vue&type=script&lang=ts"
script.render = render

export default script